import { render, staticRenderFns } from "./dynamicBox.vue?vue&type=template&id=3f1f668a&scoped=true"
import script from "./dynamicBox.vue?vue&type=script&lang=js"
export * from "./dynamicBox.vue?vue&type=script&lang=js"
import style0 from "./dynamicBox.vue?vue&type=style&index=0&id=3f1f668a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1f668a",
  null
  
)

export default component.exports